// Copyright (c) 2024. Sendanor <info@sendanor.fi>. All rights reserved.

import {
    getSendanorProductIdForOutlet,
    SendanorProductId,
} from "../../../core/types/SendanorProductId";
import { PageImage } from "../../core/types/PageImage";
import SHELL_IMAGE from "./pub/AdobeStock_134545242.jpg";
import HERO_IMAGE from "./pub/edit2.jpg";
import NET_IMAGE from "./pub/pexels-brett-sayles-2881229-small.jpg";
import NOR_EMAIL from "./pub/nor-email.jpg";
import NOR_SHELL from "./pub/nor-shell.jpg";
import NOR_WEBHOTEL from "./pub/nor-webhotel.jpg";
import NOR_VPS from "./pub/nor-virtuaalipalvelimia.jpg";
import NOR_15_YEARS from "./pub/nor-luotettavia-palveluita-15-vuotta.jpg";
import PREMIUM_DOMAIN_IMAGE from "./pub/pexels-shawn-stutzman-1010496.jpg";
import PHOTOS_IMAGE from "./pub/ai-image-sample.jpg";
import WP_IMAGE from "./pub/pexels-andrea-piacquadio-845451.jpg";
import WEBRTC_IMAGE from "./pub/pexels-pixabay-163064.jpg";
import CPU_IMAGE from "./pub/pexels-pixabay-51165-600x400.jpg";
import RAM_IMAGE from "./pub/pexels-sergei-starostin-6636474-600x400.jpg";
import HDD_IMAGE from "./pub/pexels-azamat-esenaliev-117729-600x400.jpg";
import SSD_IMAGE from "./pub/pexels-phiraphon-srithakae-11253062-600x400.jpg";
import MATRIX_IMAGE from "./pub/pexels-markusspiske-1089438.jpg";
import LenovoThinkPadX13Gen2_IMAGE from "./shop/193427-LenovoThinkPadX13Gen2.jpg";
import LenovoThinkVisionP32p20_IMAGE from "./shop/0967-LenovoThinkVisionP32p20.jpg";
import JabraSpeak710MS_IMAGE from "./shop/192959-JabraSpeak710MS.jpg";
import SamsungQ70BA55_IMAGE from "./shop/193007-SamsungQ70BA55.jpg";
import LenovoThinkpadP15vGen2_IMAGE from "./shop/193303-LenovoThinkpadP15vGen2.jpg";
import AppleMacBookAir2020_IMAGE from "./shop/193908-AppleMacBookAir2020.jpg";
import LenovoThinkVisionP27h10_IMAGE from "./shop/194851-LenovoThinkVisionP27h10.jpg";
import LenovoQ24h10_IMAGE from "./shop/200028-LenovoQ24h10.jpg";
import JBLTune760NC_IMAGE from "./shop/193737-JBLTune760NC.jpg";
import MacBookPro2020_IMAGE from "./shop/1071-MacBookPro-M1-2020.jpg";

export function getPageImage (page: PageImage) : string {
    switch (page) {
        case PageImage.INDEX: return NOR_15_YEARS;
        case PageImage.ABOUT: return NOR_15_YEARS;
        case PageImage.VIRTUALSERVERS: return NOR_VPS;
        case PageImage.EMAIL: return NOR_EMAIL;
        case PageImage.WEBHOTELS: return NOR_WEBHOTEL;
        case PageImage.DATABASE: return HERO_IMAGE;
        case PageImage.DOMAINS: return HERO_IMAGE;
        case PageImage.SHELL: return NOR_SHELL;
        case PageImage.CUSTOMER_SERVICE: return HERO_IMAGE;
        default: return HERO_IMAGE;
    }
}

export function getProductImage (product: SendanorProductId | string) : string {

    if (product.includes('#')) {
        switch (product) {

            case getSendanorProductIdForOutlet('lenovo-20XJS14W00-1'):
                return LenovoThinkPadX13Gen2_IMAGE;

            case getSendanorProductIdForOutlet('LenovoThinkVisionP32p20-1'):
                return LenovoThinkVisionP32p20_IMAGE;

            case getSendanorProductIdForOutlet('JabraSpeak710MS-1'):
                return JabraSpeak710MS_IMAGE;

            case getSendanorProductIdForOutlet('SamsungQ70BA55-1'):
                return SamsungQ70BA55_IMAGE;

            case getSendanorProductIdForOutlet('LenovoThinkpadP15vGen2-1'):
                return LenovoThinkpadP15vGen2_IMAGE;

            case getSendanorProductIdForOutlet('AppleMacBookAir2020-1'):
                return AppleMacBookAir2020_IMAGE;

            case getSendanorProductIdForOutlet('LenovoThinkVisionP27h10-1'):
                return LenovoThinkVisionP27h10_IMAGE;

            case getSendanorProductIdForOutlet('LenovoQ24h10-1'):
                return LenovoQ24h10_IMAGE;

            case getSendanorProductIdForOutlet('JBLTune760NC-1'):
                return JBLTune760NC_IMAGE;

            case getSendanorProductIdForOutlet('AppleMacBookPro2020-1'):
                return MacBookPro2020_IMAGE;

            default:
                product = product.split('#')[0];
        }

    }

    switch (product) {
        case SendanorProductId.VPS_MINI_1                  : return HERO_IMAGE;
        case SendanorProductId.VPS_1                       : return HERO_IMAGE;
        case SendanorProductId.VPS_2                       : return HERO_IMAGE;
        case SendanorProductId.VPS_3                       : return HERO_IMAGE;
        case SendanorProductId.VPS_4                       : return HERO_IMAGE;
        case SendanorProductId.VPS_5                       : return HERO_IMAGE;
        case SendanorProductId.VPS_6                       : return HERO_IMAGE;
        case SendanorProductId.VPS_7                       : return HERO_IMAGE;
        case SendanorProductId.VPS_8                       : return HERO_IMAGE;
        case SendanorProductId.VPS_CPU_1_10                : return CPU_IMAGE;
        case SendanorProductId.VPS_CPU_1_5                 : return CPU_IMAGE;
        case SendanorProductId.VPS_MEMORY_MINI_1           : return RAM_IMAGE;
        case SendanorProductId.VPS_MEMORY_1                : return RAM_IMAGE;
        case SendanorProductId.VPS_NET6_1                  : return NET_IMAGE;
        case SendanorProductId.VPS_IP4_1                   : return NET_IMAGE;
        case SendanorProductId.VPS_ETH2G_1                 : return NET_IMAGE;
        case SendanorProductId.VPS_ETH5G_1                 : return NET_IMAGE;
        case SendanorProductId.VPS_ETH10G_1                : return NET_IMAGE;
        case SendanorProductId.VPS_SAS_250                 : return HDD_IMAGE;
        case SendanorProductId.VPS_SAS_500                 : return HDD_IMAGE;
        case SendanorProductId.VPS_SAS_1000                : return HDD_IMAGE;
        case SendanorProductId.VPS_NVME_10                 : return SSD_IMAGE;
        case SendanorProductId.VPS_SUPPORT_1               : return WP_IMAGE;
        case SendanorProductId.VPS_BACKUP_RESTORE_1        : return HERO_IMAGE;
        case SendanorProductId.WEB_HOTEL_DISK_5            : return HDD_IMAGE;
        case SendanorProductId.WEB_HOTEL_DISK_25           : return HDD_IMAGE;
        case SendanorProductId.WEB_HOTEL_DISK_50           : return HDD_IMAGE;
        case SendanorProductId.WEB_SUPPORT_1               : return WP_IMAGE;
        case SendanorProductId.WEB_HOTEL_BACKUP_RESTORE_1  : return HERO_IMAGE;
        case SendanorProductId.WEB_MYSQL_1                 : return WP_IMAGE;
        case SendanorProductId.WEB_PSQL_1                  : return WP_IMAGE;
        case SendanorProductId.WEB_USER_1                  : return WP_IMAGE;
        case SendanorProductId.ATLAS_SUPPORT_1             : return WP_IMAGE;
        case SendanorProductId.ATLAS_USER_1                : return HERO_IMAGE;
        case SendanorProductId.EMAIL_DISK_10               : return HDD_IMAGE;
        case SendanorProductId.EMAIL_DISK_50               : return HDD_IMAGE;
        case SendanorProductId.EMAIL_BACKUP_RESTORE_1      : return HERO_IMAGE;
        case SendanorProductId.EMAIL_SUPPORT_1             : return WP_IMAGE;
        case SendanorProductId.WEB_1                       : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_2                       : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_TITAN_1G                : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_TITAN_2G                : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_TITAN_5G                : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_TITAN_10G               : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_TITAN_20G               : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_ATLAS_1G                : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_ATLAS_2G                : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_ATLAS_5G                : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_ATLAS_10G               : return NOR_WEBHOTEL;
        case SendanorProductId.WEB_ATLAS_20G               : return NOR_WEBHOTEL;
        case SendanorProductId.WP_1                        : return WP_IMAGE;
        case SendanorProductId.NET_1                       : return NET_IMAGE;
        case SendanorProductId.WEBRTC_1                    : return WEBRTC_IMAGE;
        case SendanorProductId.EMAIL_1                     : return NOR_EMAIL;
        case SendanorProductId.EMAIL_2                     : return NOR_EMAIL;
        case SendanorProductId.SHELL_1                     : return SHELL_IMAGE;
        case SendanorProductId.SHELL_2                     : return MATRIX_IMAGE;
        case SendanorProductId.DOMAIN                      : return PREMIUM_DOMAIN_IMAGE;
        case SendanorProductId.OUTLET                      : return WEBRTC_IMAGE;
        case SendanorProductId.SOFTWARE_GOVM_BIN_1         : return WEBRTC_IMAGE;
        case SendanorProductId.SOFTWARE_GOVM_FSL_2         : return WEBRTC_IMAGE;

        default: return HERO_IMAGE;
    }
}

export {
    PHOTOS_IMAGE,
    PREMIUM_DOMAIN_IMAGE,
    HERO_IMAGE as RESELLER_IMAGE,
    SHELL_IMAGE as INTRO_IMAGE,
    MATRIX_IMAGE as SHELL_2_IMAGE,
    WP_IMAGE as SUPPORT_IMAGE,
    WEBRTC_IMAGE,
    WEBRTC_IMAGE as SOFTWARE_IMAGE,
    SHELL_IMAGE,
    WP_IMAGE as ATLAS_IMAGE,
    NET_IMAGE,
    WP_IMAGE,
    HERO_IMAGE,
    MATRIX_IMAGE,
};
